import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Logo from '~/logo/logo_full.png';
import { useEffect, useState } from 'react';
import { MenuIcon } from '@/assets/icons';
import Button from '@/components/button';
import cx from 'classnames';
import Link from 'next/link';
import { LOGIN_URL, MENU } from '@/config-global';
import classNames from 'classnames';
import { Menu, MenuItem } from '@mui/material';

const buttonStylePc = {
  background: 'rgba(7, 25, 59, 0.8)',
  padding: '12px 24px',
  fontSize: '16px',
  marginLeft: '0px',
  marginTop: '20px',
  width: 'auto'
};

const buttonStyleMobile = {
  background: 'rgba(7, 25, 59, 0.8)',
  padding: '12px 16px',
  fontSize: '8px',
  marginLeft: '60px',
  marginTop: '5px',
  width: '123px'
};

const Header: React.FC = () => {
  const [isScroll, setScroll] = useState(false); // 滚动检测
  const [toggle, setToggle] = useState(false); // 菜单切换状态
  const router = useRouter();
  const { asPath } = router; // 当前路由路径
  const [buttonStyle, setButtonStyle] = useState(buttonStylePc);

  // 监听滚动条，滚动时改变 header 样式
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 4) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    });
  }, []);

  // 处理 Logo 点击事件，点击 Logo 时关闭菜单并跳转首页
  const handleLogoClick = async () => {
    if (toggle) {
      setToggle(false); // 关闭菜单
    }
    await router.replace('/'); // 跳转首页
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // 小屏幕样式
        setButtonStyle(buttonStyleMobile);
      } else {
        // 大屏幕样式
        setButtonStyle(buttonStylePc);
      }
    };

    // 初始化时根据屏幕尺寸设置按钮样式
    handleResize();

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);

    // 组件卸载时移除事件监听
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const PCMenu = MENU.filter((menu) => menu.showInPc);
  return (
    <>
      <header
        className={cx(
          'js-page-header fixed top-0 z-20 w-full lg:pb-4 transition-colors',
          {
            'js-page-header--is-sticky': isScroll // 滚动时添加样式
          }
        )}
      >
        <div className="flex items-center justify-between lg:px-8">
          <Link href="/" onClick={handleLogoClick}>
            <Image
              src={Logo}
              alt="Nestflo"
              className="w-[146px] lg:w-[200px]"
            />
          </Link>
          <div className="hidden flex-1 items-center justify-end space-x-5 pb-1 lg:flex">
            <nav className="navbar w-full lg:mt-4">
              <ul className="flex flex-col items-center justify-center lg:flex-row">
                {PCMenu.map((item, index) => (
                  <Link
                    href={item.href}
                    className="group relative"
                    key={index}
                    onMouseEnter={
                      item.title === 'TESTIMONIALS'
                        ? (e) => setAnchorEl(e.currentTarget)
                        : undefined
                    }
                  >
                    <button
                      className={classNames(
                        'uppercase text-jacarta-700 font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex w-full items-center justify-between !bg-clip-text py-3.5 text-base font-bold text-transparent  lg:px-5',
                        {
                          '[-webkit-background-clip:text] [-webkit-text-fill-color:transparent] [background:linear-gradient(180deg,_#ede6ff,_#D43A1A)]':
                            asPath.includes(item.href), // 当前路由高亮显示
                          '[-webkit-background-clip:text] [-webkit-text-fill-color:transparent] [background:linear-gradient(180deg,_#EDE5FF,_#0B6A99)]':
                            !asPath.includes(item.href) // 其他路由样式
                        }
                      )}
                      type="button"
                    >
                      <span className="text-accent">{item.title}</span>
                    </button>
                  </Link>
                ))}
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  slotProps={{
                    paper: {
                      onMouseLeave: handleClose,
                      sx: {
                        backgroundColor: 'rgba(1,0,4)',
                        border: '1px solid #25076F',
                        '& .MuiMenuItem-root': {
                          // backgroundColor: 'blue',
                          color: 'white',
                          minHeight: '45px',
                          '&:hover': {
                            backgroundImage:
                              'linear-gradient(rgba(41, 12, 111, 1) 0%,rgba(36, 17, 85, 1) 100%)'
                          }
                        },
                        borderRadius: 4
                      }
                    }
                  }}
                  MenuListProps={{
                    sx: {
                      paddingTop: 0,
                      paddingBottom: 0
                    }
                  }}
                  disableScrollLock={true}
                >
                  <MenuItem
                    component={Link}
                    sx={{
                      ...(asPath === '/look#CaseStudy' && {
                        background:
                          'linear-gradient(rgba(41, 12, 111, 1) 0%,rgba(36, 17, 85, 1) 100%)',
                        color: '#fff'
                      })
                    }}
                    onClick={handleClose}
                    href="/look#CaseStudy"
                  >
                    Case Study
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    sx={{
                      ...(asPath === '/#syzo_ltd' && {
                        background:
                          'linear-gradient(rgba(41, 12, 111, 1) 0%,rgba(36, 17, 85, 1) 100%)',
                        color: '#fff'
                      })
                    }}
                    onClick={handleClose}
                    href="/#syzo_ltd"
                  >
                    Video Testimonials
                  </MenuItem>
                </Menu>
              </ul>
            </nav>
          </div>

          {/* Book Demo 按钮 */}
          <Button
            variant="outline"
            className="mr-4 mt-3 hidden pr-7 uppercase tracking-[0.5em] md:mr-0 lg:block"
            style={buttonStyle}
            onClick={() => {
              window.location.href = LOGIN_URL;
            }}
          >
            Login
          </Button>

          {/* 移动端菜单按钮 */}
          <div className="ml-auto flex justify-center lg:hidden">
            <button
              className="js-mobile-toggle"
              aria-label="open mobile menu"
              onClick={() => setToggle(true)}
            >
              <MenuIcon
                className="text-gray-400 size-12 -ml-1 mr-4"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </header>

      {/* 移动端菜单 */}
      <div
        className={`js-mobile-menu menu-bg invisible fixed inset-0 z-20 ml-auto items-center bg-dark opacity-0 transition duration-500 ease-in-out lg:visible lg:relative lg:inset-auto lg:hidden lg:bg-transparent lg:opacity-100 ${
          toggle ? 'nav-menu--is-open' : 'hidden'
        }`}
      >
        <div className="t-0 fixed left-0 z-10 flex w-full items-center justify-center lg:hidden">
          <Link href="/" onClick={handleLogoClick}>
            <Image
              src={Logo}
              alt="Nestflo"
              className="w-[146px] lg:w-[200px]"
            />
          </Link>
        </div>
        <button
          className="absolute right-4 top-4 z-50"
          onClick={() => setToggle(false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6 text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* 移动端菜单导航 */}
        <nav className="navbar mt-24 w-full">
          <ul className="flex flex-col lg:flex-row">
            {MENU.map((item, index) => (
              <li
                className="group relative text-center"
                onClick={() => setToggle(false)}
                key={index}
              >
                <Link
                  href={item.href}
                  className={classNames(
                    'uppercase font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex w-full items-center justify-center !bg-clip-text py-3.5 text-base font-bold lg:px-5',
                    { 'text-xs text-white': !item.showInPc },
                    {
                      'text-[#D43A1A]': asPath === item.href, // 当前路由高亮显示
                      'text-[#0B6A99]': asPath !== item.href // 其他路由样式
                    }
                  )}
                >
                  <span className="text-center">{item.title}</span>
                </Link>
              </li>
            ))}

            {/* 移动端菜单中的 Book Demo 按钮 */}
            <li
              className="group relative text-center"
              onClick={() => setToggle(false)}
            >
              <Button
                variant="outline"
                className=" mt-6 uppercase tracking-[0.5em]"
                style={{
                  background: 'rgba(7, 25, 59, 0.8)'
                }}
                onClick={() => {
                  window.location.href = LOGIN_URL;
                }}
              >
                Login
              </Button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
